<template>
  <div class="pa-2">
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else-if="filteredTickets.length">
      <template v-for="ticket in filteredTickets">
        <ticket-item
          :key="ticket.id"
          :value="ticket"
          :pageid="pageid"
          @editTicketSuccess="onEditTicketSuccess"
        ></ticket-item>
      </template>
    </div>
    <div v-else class="text-xs-center">
      <h5>ไม่พบข้อมูล</h5>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import TicketItem from './TicketItem'
export default {
  props: ['value', 'byadminid', 'filter', 'pageid'],
  components: {
    TicketItem
  },
  data() {
    return {
      loading: false,
      tickets: [],
      timer: null
    }
  },
  async mounted() {
    var vm = this
    this.$root.$on('loadTicket', () => {
      this.initTicketList()
    })
    vm.initTicketList()
  },
  beforeDestroy: function () {},
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      currentUserTicketLoading: 'currentUserTicketLoading'
    }),
    filteredTickets() {
      var result
      if (this.$store.state.privilege) {
        if (
          this.selectedBot.theme == 'ticket' ||
          this.$store.state.ticketPageid.includes(this.selectedBot.pageid) ||
          ['gpf', 'mtc'].includes(this.selectedBot.type)
        ) {
          switch (this.$store.state.privilege.view_ticket) {
            case 'all':
              result = this.tickets
              break
            case 'only_me':
              result = this.tickets.filter((el) => {
                return el.assignadminid == this.$store.state.userid
              })
              break
            case 'only_group':
              result = this.tickets.filter((el) => {
                return el.assigngroupid == this.$store.state.admingroupid
              })
              break
            case 'only_subgroup':
              result = this.tickets.filter((el) => {
                return el.assignsubgroupid == this.$store.state.adminsubgroupid
              })
              break
            default:
              result = []
          }
        } else if (
          ['studio7', 'ticket2', 'ustore', 'tdtawandang', 'cityfresh'].includes(
            this.selectedBot.theme
          ) ||
          [...this.$store.state.toaPaintPage].includes(this.selectedBot.pageid)
        ) {
          // if (['superadmin', 'systemadmin'].includes(this.$store.state.privilege.role)) {
          result = this.tickets
          // } else {
          //   result = this.tickets.filter(el => {
          //     return el.assignadminid == this.$store.state.userid
          //   })
          // }
        }
      } else {
        result = []
      }
      if (this.filter) {
        result = result.filter((el) => el.status == this.filter)
      }
      return result
    }
  },
  watch: {
    currentUserTicketLoading(newVal) {
      alert(newVal)
    }
  },
  methods: {
    async initTicketList() {
      this.loading = true

      if (this.$store.state.privilege) {
        var filter = {}
        var view_ticket = this.$store.state.privilege.view_ticket
        if (view_ticket == 'all') {
          // dont do shit
        } else if (view_ticket == 'only_me') {
          Object.assign(filter, {
            assignadminid: this.$store.state.userid
          })
        } else if (view_ticket == 'only_group') {
          Object.assign(filter, {
            assigngroupid: this.$store.state.admingroupid
          })
        } else if (view_ticket == 'only_subgroup') {
          Object.assign(filter, {
            assignsubgroupid: this.$store.state.adminsubgroupid
          })
        }
      }

      if (this.byadminid) {
        var response = await this.getTicketByAdminId()
      } else {
        var response = await this.getTicketListByUser(filter)
      }

      if (response.data && response.data.length > 0) {
        this.tickets = response.data
        this.$store.commit('SET_TICKET_LOADING', false)
        this.$store.commit('SET_CURRENT_USER_TICKET', this.tickets)
      }

      this.$store.dispatch('loadAgentGroups')
      this.$store.dispatch('loadAgentSubGroups')
      this.$store.dispatch('loadAgents')
      this.loading = false
    },
    getTicketListByUser(filter = []) {
      var data = {
        userid: this.value,
        pageid: this.pageid,
        ...filter
      }
      return new Promise((resolve, reject) => {
        api.getTicketListByUser(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getTicketByAdminId() {
      var data = {
        adminid: this.value,
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getTicketByAdminId(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async onEditTicketSuccess() {
      this.loading = true
      var response = await this.getTicketListByUser()
      if (response.data && response.data.length > 0) {
        this.tickets = response.data
        this.$store.commit('SET_TICKET_LOADING', true)
        this.$store.commit('SET_CURRENT_USER_TICKET', this.tickets)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/TicketList.vue